/**
 * Visually-hidden aria-live region for screen-reader announcement of
 * in-flight bulk actions.
 *
 * Include exactly one per table/section that participates in bulk actions.
 * Announces count changes politely so screen readers pick up the transition
 * when a bulk job starts or finishes.
 *
 * UX divergence #6: one region per table, NOT one per row.
 */

import { useBulkJobsStore } from '@/state/bulkJobs.store';

export function BulkActivityAnnouncer() {
  const activeCount = useBulkJobsStore(state => state.activeCount());

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {activeCount > 0
        ? `${activeCount} bulk action${activeCount === 1 ? '' : 's'} in progress`
        : ''}
    </div>
  );
}
